module.exports = __webpack_public_path__ + "media/images/squared-5t-9b2ba0d1d709cfa826ae602d7b200ac9.png";